import { useEffect, useMemo, useState } from 'react';
import AppFile from '../../models/AppFile';
import { FileUploaderMessage } from '../workers/fileUploader';
import { FileType } from '../../models/FileType';

const useFileUploader = (defaultFile: AppFile | null, documentType: FileType) => {
  const [appFile, setAppFile] = useState<AppFile | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const worker = useMemo(() => {
    return new Worker(
      new URL('../workers/fileUploader.ts', import.meta.url)
    );
  }, [])

  useEffect(() => {
    setAppFile(defaultFile);
    return () => {
      worker.terminate();
    };
  }, []);

  const changeFile = (file: File | null) => {
    if (file == null) {
      setAppFile(null);
    } else {
      setLoading(true);
      worker.addEventListener('message', (message: MessageEvent<string>) => {
        const newAppFile = JSON.parse(message.data)
        setAppFile({ ...newAppFile, file });
        setLoading(false);
      });
      const message: FileUploaderMessage = {
        file,
        documentType
      }
      worker.postMessage(message);
    }
  }

  return { appFile, changeFile, loading };
};

export default useFileUploader;
